import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import {
  FormFieldComponent,
  FormInputSelectComponent,
  FormInputSelectionDirective,
} from '@libs/ui';
import { AnalysisNavigationService } from 'demand-forecasting/analysis/services/analysis-navigation.service';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';
import { selectAnalysisConfigurationIdByQueryParam } from 'demand-forecasting/store/router-state/router.selectors';

@Component({
  selector: 'pm-analysis-configuration-picker',
  templateUrl: './analysis-configuration-picker.component.html',
  imports: [
    TranslateModule,
    FormFieldComponent,
    FormInputSelectComponent,
    FormsModule,
    FormInputSelectionDirective,
  ],
})
export class AnalysisConfigurationPickerComponent {
  private readonly store = inject(Store);
  private readonly analysisNavigationService = inject(
    AnalysisNavigationService,
  );

  protected analysisStateService = inject(AnalysisStateService);

  protected selectedAnalysisConfigurationId = this.store.selectSignal(
    selectAnalysisConfigurationIdByQueryParam,
  );

  protected analysisConfigurationOptions = computed(() => {
    if (!this.analysisStateService.configurations.hasValue()) {
      return [];
    }
    return this.analysisStateService.configurations.value().map((c) => ({
      label: c.name,
      value: c.id,
      descriptionKey: `ANALYSIS.ANALYSIS_TYPE.${c.analysisType.toUpperCase()}`,
    }));
  });

  protected configurationSelectionChanged(
    analysisConfigurationId: string | (string | undefined)[] | undefined,
  ) {
    if (!analysisConfigurationId || Array.isArray(analysisConfigurationId)) {
      return;
    }

    const configurations = this.analysisStateService.configurations.value();
    const matchingConfiguration = configurations?.find(
      (c) => c.id === analysisConfigurationId,
    );

    if (!matchingConfiguration) {
      console.error(
        `No matching configuration found for ID: ${analysisConfigurationId}`,
      );
      return;
    }

    const latestVersion = matchingConfiguration.latestAnalysisVersion;
    const versionId = latestVersion ? latestVersion.id : null;

    this.analysisNavigationService.setQueryParams({
      analysisConfigurationId,
      versionId,
      hierarchy: null,
      filter: null,
    });
  }
}
